export default __webpack_public_path__ + "static/media/biometricTimeClock.f68a7dd4.svg";